import React from "react";
import type { ViewComponent } from "@frui.ts/views";
import { registerView } from "@frui.ts/views";
import LoaderOverlay from "@edaz/edazkit/LoaderOverlay";
import { observer } from "mobx-react-lite";
import ExemptionDetailViewModel from "viewModels/callCenter/search/exemptions/detailExemption/exemptionDetailViewModel";
import ExemptionDetailSection from "./exemptionDetailSection";
import ExemptionVehicleRegisterSection from "./exemptionVehicleRegisterSection";
import { Col } from "react-bootstrap";

export const ExemptionDetailView: ViewComponent<ExemptionDetailViewModel> = observer(({ vm }) => {
  if (!vm.item) {
    return (
      <LoaderOverlay loading={true}>
        <div style={{ minHeight: 200 }}></div>
      </LoaderOverlay>
    );
  }

  return (
    <div className="d-flex">
      {vm.item.exemptionDetail && (
        <Col className="p-0">
          <Col lg={12} className="pr-3 pl-0">
            <ExemptionDetailSection vm={vm} />
          </Col>
        </Col>
      )}
      {vm.item.vehicleRegisterVehicleDetail && (
        <Col className="p-0">
          <Col lg={12} className="pr-3 pl-0">
            <ExemptionVehicleRegisterSection vm={vm} />
          </Col>
        </Col>
      )}
    </div>
  );
});

registerView(ExemptionDetailView, ExemptionDetailViewModel);
